<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    import mqtt from "mqtt";

    export default {
        name: "App",
        data() {
            return {}
        },
        created() {
            this.mqttConnect();
        },
        mounted() {},
        methods: {
            mqttConnect() {
                var client = mqtt.connect("mqtt://local.vrmaker.vip:8083/mqtt", {
                    username: "vrmaker",
                    password: "vrmaker",
                });

                client.on("connect", () => {
                    console.log("Mqtt connected ...");
                    // 总负荷
                    client.subscribe([
                        "VrMaker/KingSrich/+/PUBLISH/+/+/P",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/PA_total",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/PF",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/PR",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/PA",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/Ia",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/Ib",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/Ic",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/Ua",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/Ub",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/Uc",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/Ub",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/Temperature",
                        "VrMaker/KingSrich/+/PUBLISH/+/+/Status/Network",
                    ]);
                });

                client.on("message", (topic, message) => {

                    let keys = topic.split('/')
                    let len = keys.length
                    let topicName = keys[len - 3] + '/' + keys[len - 2] + '/' + keys[len - 1]

                    // console.log(topicName, parseInt(message));

                    this.$store.commit("addMQTTData", {
                        key: topicName,
                        val: message,
                    });
                });

                client.on("error", (err) => {
                    console.log("mqtt error !!!", err);
                    client.end();
                });

                client.on("close", () => {
                    console.log("mqtt closed!");
                });
            },
        },
    };
</script>

<style lang="less">
    @import "./assets/fonts/font.css";
    @import "./assets/css/global";
    @import "./assets/css/func";
</style>